import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';

const resizeAndCropImage = (file, callback) => {
  const reader = new FileReader();
  reader.onload = (event) => {
    const img = new Image();
    img.src = event.target.result;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const size = 400;

      // Set canvas size to 400x400
      canvas.width = size;
      canvas.height = size;

      // Calculate crop area
      const minDim = Math.min(img.width, img.height);
      const sx = (img.width - minDim) / 2;
      const sy = (img.height - minDim) / 2;

      ctx.drawImage(img, sx, sy, minDim, minDim, 0, 0, size, size);

      canvas.toBlob(
        (blob) => {
          const resizedFile = new File([blob], file.name, {
            type: file.type,
          });
          callback(resizedFile);
        },
        'image/jpeg',
        0.8
      );
    };
  };
  reader.readAsDataURL(file);
};

const DropzoneManage = ({ onDropHandler, imageName, person, photo }) => {
  const onDrop = async (acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      resizeAndCropImage(file, (resizedFile) => {
        onDropHandler({ name: file.name, uri: resizedFile, person: person });
      });
    });
  };

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({ onDrop });

  const dzStyle = useMemo(
    () =>
      [
        'dzBase',
        isFocused ? 'focusedStyle' : '',
        isDragAccept ? 'acceptStyle' : '',
        isDragReject ? 'rejectStyle' : '',
      ].join(' '),
    [isFocused, isDragAccept, isDragReject]
  );

  return (
    <section className="dzContainer mb-3">
      <div {...getRootProps()} className={dzStyle}>
        <input {...getInputProps()} />
        <img src={photo} width={100} alt="uploaded staff headshot" />
      </div>
    </section>
  );
};

export default DropzoneManage;
